import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MappedUserProfile } from "modules/dashboard";

interface State {
    isLoading: boolean;
    isUpdating: boolean;
    isError: boolean;
    isSuccess: boolean;
    errorMessage: string;
    profile: MappedUserProfile | null;
}

interface GetProfileSuccess {
    profile: any;
}
interface RequestError {
    errorMessage: string;
}

const initialState: State = {
    isLoading: false,
    isUpdating: false,
    isError: false,
    isSuccess: false,
    errorMessage: "",
    profile: null,
};

const profileSlice = createSlice({
    name: "Profile",
    initialState: initialState,
    reducers: {
        getProfileRequest: state => {
            state.isLoading = true;
        },
        getProfileSuccess: (state, action: PayloadAction<GetProfileSuccess>) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.profile = action.payload.profile;
        },
        getProfileError: (state, action: PayloadAction<RequestError>) => {
            state.isLoading = false;
            state.isError = true;
            state.errorMessage = action.payload.errorMessage;
        },
        updateProfileRequest: state => {
            state.isUpdating = true;
        },
        updateProfileSuccess: state => {
            state.isUpdating = false;
            state.isSuccess = true;
        },
        updateProfileError: state => {
            state.isUpdating = false;
            state.isError = true;
        },
        updateModuleManagementSuccess: (state, action: PayloadAction<number>) => {
            state.isUpdating = false;
            state.isSuccess = true;

            if (!state.profile) {
                return;
            }

            const nextModules = new Set(state.profile.moduleName ?? []);
            if (nextModules.has(action.payload)) {
                nextModules.delete(action.payload);
            } else {
                nextModules.add(action.payload);
            }

            state.profile = {
                ...state.profile,
                moduleName: Array.from(nextModules),
            };
        },
    },
});

const { actions } = profileSlice;

export const {
    getProfileRequest,
    getProfileSuccess,
    getProfileError,
    updateProfileRequest,
    updateProfileSuccess,
    updateProfileError,
    updateModuleManagementSuccess,
} = actions;

export const profileReducer = profileSlice.reducer;
